import { jsx as r } from "react/jsx-runtime";
import { Popconfirm as n } from "antd";
import { useLanguageResolver as m } from "@biron-data/react-contexts";
const f = ({ children: e, ...t }) => {
  const o = m();
  return /* @__PURE__ */ r(n, { okText: o.get("common.popconfirm.okText"), cancelText: o.get("common.popconfirm.cancelText"), okButtonProps: {
    danger: !0
  }, icon: /* @__PURE__ */ r("div", {}), ...t, children: e });
};
export {
  f as default
};
//# sourceMappingURL=Popconfirm.js.map
